import { mapGetters } from 'vuex';
import mvtNearby from '@/common/components/mvtnearby/mvt-nearby.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';
import lazyCarouselCheckMixin from '@/common/mixins/lazycarouselcheck';

export default {
    name: 'propertyNearByCity',
    props: ['disableCollapse', 'theme'],
    components: {
        mvtNearby,
        mvtLazyload,
    },
    mixins: [lazyCarouselCheckMixin],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp']),
        getMSPlink() {
            return this.glb.appUrl + this.dpp.geo.newPath;
        },
    },
    methods: {
        completedNearbyCity() {
            this.$refs.lazyloadNearbyCity.ready();
        },
        getMSPLink(filter) {
            return this.glb.appUrl + this.dpp.geo.zipcodePath + filter + '/';
        },
    },
};
